// flow
import React from 'react';

type Props = {
  value: string,
  onChange?: (time: string) => void,
  required?: boolean,
  id?: string,
  name?: string,
  disabled?: boolean,
  readOnly?: boolean,
}

class DurationPicker extends React.Component<Props> {
  state = {
    selection: 0,
    backFired: false,
  };

  ref;

  componentDidUpdate = () => {
    const {selection} = this.state;
    this.ref.setSelectionRange(selection, selection);
  }

  onFocus = (event) => {
    event.target.setSelectionRange(0, 0);
  }

  setRef = (ref) => {
    this.ref = ref;
  };

  handleInput = ({ target }) => {
    const {
      selectionStart,
      selectionEnd,
      value
    } = target;

    const {onChange} = this.props;

    if (selectionStart !== selectionEnd) {
      return;
    }

    let processedValue = value;
    processedValue = processedValue.split(":").join('');

    let hours = processedValue.slice(0, 2);
    let minutes = processedValue.slice(2, 4);

    if (hours.length < 2) {
      hours = selectionStart === 0 ? "0" + hours : hours + "0";
    }
    if (minutes.length < 2) {
      minutes = selectionStart === 2 ? "0" + minutes : minutes + "0";
    }

    processedValue = hours + ":" + minutes;

    this.setState({
      selection: selectionStart,
    })

    if (processedValue.match(/^(0?[0-9]|1[0-2]):[0-5][0-9]$/)) {
      if (onChange) {
        onChange(processedValue);
      }
    }
  }

  render() {
    const { value, required, id, name, disabled, readOnly, label} = this.props;

    return (
      <div className="timepicker-wrapper">
        {label && (
          <label className="timepicker-label" htmlFor={id}>{label}</label>
        )}
        <input
          className="timepicker-input datepicker-input"
          ref={this.setRef}
          type={"text"}
          onChange={this.handleInput}
          onFocus={this.onFocus}
          value={value}
          required={required}
          id={id}
          name={name}
          disabled={disabled}
          readOnly={readOnly}
        />
      </div>)
  }
}

export default DurationPicker;
